import { BASE_JOURNEY_ID } from './baseJourney'

/** Answers with the journey in hand, and re-renders its caller when it moves. */
type ReadActiveJourneyId = () => string

/*
 * The base journey, for anything that registers nothing.
 *
 * The portal has no journeys and never will have this registered, so it reads
 * the one journey every user has — which is exactly what it shows today.
 */
const readBaseJourney: ReadActiveJourneyId = () => BASE_JOURNEY_ID

let read: ReadActiveJourneyId = readBaseJourney

/**
 * Hands core the way to ask which journey the app is on.
 *
 * A reader rather than a copy: the answer lives in the host, and a copy here
 * would be a second thing to keep in step.
 *
 * Call it once, at startup. `useActiveJourneyId` calls whatever is registered,
 * so swapping it between renders would change the hooks a component runs.
 */
export const setActiveJourneyIdReader = (next: ReadActiveJourneyId): void => {
  read = next
}

/** The journey in hand. Never absent: it falls back to the base one. */
export const useActiveJourneyId = (): string => read()
